export default __webpack_public_path__ + "static/media/react.dca8df3b.jpg";